<span class="preorder-tag" [ngClass]="{'right-round': roundedSide == 'right', 'whole-round': roundedSide == 'whole'}" *ngIf="menuItem.leadTime && menuItem.leadTime.value">
  <p class="day-description" *ngIf="menuItem.leadTime.type == leadTimeType.Day">
    {{menuItem.leadTime.value}} {{"day" | translate}} {{"order.info.delivery.status.des.4" | translate}}
  </p>
  <p class="hour-description" *ngIf="menuItem.leadTime.type == leadTimeType.Hour">
    {{menuItem.leadTime.value | dayHoursConverter }} {{"order.info.delivery.status.des.4" | translate}}
  </p>
</span>
